import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { getKeysBySortedNumberValues } from '../../../../../utils/object/get-sorted-number-values'

function getOrderedEquipmentWorkoutUtil (workout) {
  const equipment = getValueReduxUtil(workout, WORKOUT_KEY.EQUIPMENT)
  return getKeysBySortedNumberValues(equipment)
}

export default getOrderedEquipmentWorkoutUtil
